<script>
import TablePage from '../../../../components/table_page';
import Form from '../../../process/components/process_approve/approve.vue';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      tablePage: {
        pageSize: 8,
      },
      configs: {
        pagination: false,
        tableConfig: {
          border: 'inner',
        },
      },
      params: {
        status: '1',
        pageNum: 1,
        pageSize: 15,

      },
      isCalculateHeight: false,
    };
  },
  created() {
    this.getConfigList('equity_redemption_record_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'view') {
        this.$router.push({ path: '/terminalFxh/equity_redemption_record' });
      }
    },
  },
};
</script>
